export default "__VITE_ASSET__E1tKBmm5__"